let $mapCanvas = $('#map-canvas');

if ($mapCanvas.length > 0) {
    // load map when scrolled into view
    const mapObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                loadLeafletMap(entry.target);
                observer.unobserve(entry.target)
            }
        })
    });
    mapObserver.observe($mapCanvas.get(0));
}

const loadLeafletMap = function (element) {
    const $mapCanvas = $(element);

    const latitude = $mapCanvas.data('center-lat') || 52.37;
    const longitude = $mapCanvas.data('center-long') || 4.89;
    const zoom = $mapCanvas.data('zoom') || 14;
    const locations = $mapCanvas.data('locations') || [];

    const map = L.map(element, {
        center: [latitude, longitude],
        zoom: zoom,
        scrollWheelZoom: false,
        tap: false
    });

    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
    }).addTo(map);

    const pin_icon = L.icon({
        iconUrl: mapIconPath,
        iconSize: [40, 40],
        iconAnchor: [20, 40],
        popupAnchor: [0, -35]
    });

    for (const location of locations) {
        if (location.lat && location.lon) {

            let myMarker;

            // create marker
            myMarker = L.marker([location.lat, location.lon], {icon: pin_icon});

            // add marker id property (corresponding with locations-list location items)
            myMarker.customMarkerID = 'location-pin-' + location.ID;

            // add marker to map
            myMarker.addTo(map).bindPopup(location.popup_content);
        }
    }
}